<div class="dropdown">
  <button *ngIf="releases.length > 0" aria-expanded="false" aria-haspopup="true"
          class="btn dark-input app-version hoverable"
          data-toggle="dropdown" id="app-version" type="button">
    {{releases[0].tag_name.substr(1)}}
  </button>
  <div aria-labelledby="app-version" class="dropdown-menu dark-input releases-menu">
    <div *ngFor="let release of releases">
      <a [href]="release.html_url" class="release-title" rel="noopener noreferrer" target="_blank">
        {{release.name}}
      </a>
      <span class="release-date ml-2">{{release.published_at.substr(0, 10)}}</span><br>
      <p class="release-body">{{release.body}}</p>
      <hr class="dropdown-divider">
    </div>
  </div>
